import { useState, useEffect } from "react";
import Devices from "../components/Devices";
import { customerContext } from "../context/contexts";
import { boxStyle, searchStyle, headerStyle } from "../style/style";
import { Box, Card } from "@mui/material";
import DeviceDetail from "../components/DeviceDetail";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import UserDrawer from "../components/UserComponent/UserDrawer";
import UserSetting from "../components/UserComponent/UserSetting";
import CustomerHubs from "../components/CustomerComponent/CustomerHubs";

export default function CustomerPage() {
  const [manage, setmanage] = useState({
    Devices: true,
    deviceDetail: false,
    billing: false,
    Settings: false,
    refresh: false,
  });

  const [id, setid] = useState();
  const [enter, setenter] = useState(
    manage.Devices
      ? sessionStorage.getItem("search_devices")
        ? true
        : false
      : false,
  );
  const [search, setsearch] = useState(
    manage.Devices
      ? sessionStorage.getItem("search_devices")
        ? sessionStorage.getItem("search_devices")
        : ""
      : "",
  );
  const history = useNavigate();
  useEffect(() => {
    if (
      sessionStorage.getItem("token") === "" ||
      !sessionStorage.getItem("token")
    ) {
      alert("Please log in to view this page!");
      history({ pathname: "/" });
    }
  }, [history]);

  const customer_id = sessionStorage.getItem("customer_id");
  const handleSearch = (e) => {
    setsearch(e.target.value);
    if (e.target.value === "") {
      setenter(true);
      sessionStorage.removeItem("search_devices");
    }
  };
  const user_id = sessionStorage.getItem("user_id");
  return (
    <div>
      {localStorage.getItem("role") === "USER" ? (
        <customerContext.Provider
          value={{ manage: manage, setmanage: setmanage, id: id, setid: setid }}
        >
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <UserDrawer setenter={setenter} setsearch={setsearch} />
                </Grid>
                <Grid item xs={10}>
                  {manage.Devices && (
                    <Box sx={boxStyle}>
                      <Card sx={{ marginRight: "60px" }}>
                        <Card sx={headerStyle}>
                          Device List
                          {!manage.deviceDetail && (
                            <form
                              style={searchStyle}
                              onSubmit={(e) => {
                                e.preventDefault();
                                sessionStorage.setItem(
                                  "search_devices",
                                  search,
                                );
                                setenter(true);
                              }}
                            >
                              <FormControl variant="standard" sx={searchStyle}>
                                <InputLabel htmlFor="input-with-icon-adornment">
                                  Search Device
                                </InputLabel>
                                <Input
                                  id="input-with-icon-adornment"
                                  startAdornment={
                                    <InputAdornment position="start">
                                      <SearchSharpIcon color="primary" />
                                    </InputAdornment>
                                  }
                                  value={search}
                                  onChange={handleSearch}
                                />
                              </FormControl>
                            </form>
                          )}
                        </Card>
                      </Card>
                      <Card
                        sx={{
                          marginRight: "60px",
                          marginTop: "20px",
                          width: "auto",
                        }}
                      >
                        <Devices
                          id={customer_id}
                          search={enter ? search : ""}
                        />
                      </Card>
                    </Box>
                  )}

                  {manage.Settings === true && (
                    <Box sx={boxStyle}>
                      <UserSetting customer_id={user_id} />
                    </Box>
                  )}
                  <Box> {manage.deviceDetail === true && <DeviceDetail />}</Box>
                  {manage.Hubs === true && (
                    <Box sx={boxStyle}>
                      <Card>
                        <div style={headerStyle}>
                          Hubs
                          <form
                            style={searchStyle}
                            onSubmit={(e) => {
                              e.preventDefault();
                              setenter(true);
                            }}
                          >
                            <FormControl variant="standard" sx={searchStyle}>
                              <InputLabel htmlFor="input-with-icon-adornment">
                                Search Hub
                              </InputLabel>
                              <Input
                                id="input-with-icon-adornment"
                                startAdornment={
                                  <InputAdornment position="start">
                                    <SearchSharpIcon color="primary" />
                                  </InputAdornment>
                                }
                                value={search}
                                onChange={handleSearch}
                              />
                            </FormControl>
                          </form>
                        </div>
                      </Card>
                      <Card sx={{ marginTop: "10px" }}>
                        <Box sx={{ margin: "1.25rem" }}>
                          <CustomerHubs
                            search={enter ? search : ""}
                            id={customer_id}
                          />
                        </Box>
                      </Card>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </customerContext.Provider>
      ) : (
        alert("You do not have permission to access this resource.")
      )}
    </div>
  );
}
